<template>
  <div>
    <modal @close="onCancel">
      <h3 slot="header">{{ challenge.name }} - {{ challenge.nameEng }}</h3>
      <div slot="body">
        <slot
          name="extra">

          <grid-row column-align="left">
            <grid-col col-size="2">
              <h4>{{ $t('health.challenge.type') }}</h4>
            </grid-col>
            <grid-col col-size="2">
              {{ $t('health.challenge.types.' + challenge.type) }}
            </grid-col>
          </grid-row>

          <grid-row column-align="left">
            <grid-col col-size="2">
              <h4>{{ challenge.startDate }}</h4>
            </grid-col>
            <grid-col col-size="2">
              <h4>{{ challenge.endDate }}</h4>
            </grid-col>
          </grid-row>

          <grid-row column-align="left">
            <grid-col col-size="2">
              <h4>{{ $t('health.challenge.category') }}</h4>
            </grid-col>
            <grid-col col-size="2">
              {{challenge.category != null ? $t('health.challenge.categories.' + challenge.category) : '' }}
            </grid-col>
          </grid-row>

          <grid-row column-align="left">
            <grid-col col-size="2">
              <h4>{{ $t('health.challenge.description') }}</h4>
            </grid-col>
            <grid-col col-size="3">
              {{ challenge.description }}
            </grid-col>
          </grid-row>

          <grid-row column-align="left">
            <grid-col col-size="2">
              <h4>{{ $t('health.challenge.descriptionEng') }}</h4>
            </grid-col>
            <grid-col col-size="3">
              {{ challenge.descriptionEng }}
            </grid-col>
          </grid-row>

          <grid-row column-align="left" v-if="isAccumulatedMode">
            <grid-col col-size="2">
              <h4>{{ $t('health.challenge.resultDescription') }}</h4>
            </grid-col>
            <grid-col col-size="3">
              {{ challenge.resultDescription }}
            </grid-col>
          </grid-row>

          <grid-row column-align="left" v-if="isAccumulatedMode">
            <grid-col col-size="2">
              <h4>{{ $t('health.challenge.resultDescriptionEng') }}</h4>
            </grid-col>
            <grid-col col-size="3">
              {{ challenge.resultDescriptionEng }}
            </grid-col>
          </grid-row>

          <h4>{{ $t('health.challenge.formula') }}</h4>
          {{ challenge.formula }}
        </slot>
      </div>
    </modal>
  </div>
</template>

<script>
import BtnPill from '@/components/shared/buttons/BtnPill';
import LabelSelect from '@/components/shared/forms/LabelSelect';
import Modal from '@/components/shared/dialogs/Modal';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';

export default {
  components: {
    BtnPill,
    LabelSelect,
    Modal,
    GridRow,
    GridCol
  },
  props: {
    challenge: {
      type: Object
    }
  },
  created () {
    document.body.addEventListener('keyup', this.onKeyUp);
  },
  destroyed () {
    document.body.removeEventListener('keyup', this.onKeyUp);
  },
  computed: {
    isAccumulatedMode () {
      return this.challenge.type === 'accumulated';
    }
  },
  methods: {
    onCancel (event) {
      this.$emit('close', event);
    },
    onKeyUp (event) {
      switch (event.keyCode) {
        case 27:
          this.$emit('close', event);
          break;
      }
    }
  }
};

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/brand/health/components/challenge/ChallengeDataModal.vue